import { render, staticRenderFns } from "./RetireResponsibilityCatelog.vue?vue&type=template&id=48147ecd"
import script from "./RetireResponsibilityCatelog.vue?vue&type=script&lang=js"
export * from "./RetireResponsibilityCatelog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports